import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { resetDrillDown } from '@store/filterContainer/actions';
import { pushDrilldownFilter } from '@store/dimensionContainer/actions';
import { applyFilter } from '@store/common/actions';
import { presetFidSelector, isCompareModalSelector } from '@store/common/selectors';
import { selector as summaryContainerSelector } from '@store/summaryContainer';
import DataSourceFilter from './DataSourceFilter';

const fidSelector = createSelector(
  presetFidSelector,
  summaryContainerSelector,
  (presetFid, summaryContainerStore) => {
    // preset filter is applied
    if (presetFid) {
      return presetFid;
    }

    // drilldown on preset filter
    // preset filters can only be applied on level-1
    const { drilldown } = summaryContainerStore;
    if (drilldown.length > 0 && drilldown[1]) {
      return drilldown[1].presetFid;
    }

    return null;
  },
);

const selector = createSelector(
  fidSelector,
  isCompareModalSelector,
  (presetFid, isCompareMode) => ({
    presetFid,
    isCompareMode,
  }),
);

export default connect(selector, {
  applyFilter,
  resetDrillDown,
  pushDrilldownFilter,
})(DataSourceFilter);
